import {
  fetchTrendingCourses,
  fetchPopularCourses,
  fetchNewCourses,
  fetchCourseByIdWithTopicLessons,
  fetchFeaturedCourses,
  postCourseFeedback,
  fetchAllCourses,
} from '../../../models/courses'

const getCourseByIdWithTopicLessons = async (context, data) => {
  try {
    const response = await fetchCourseByIdWithTopicLessons(data)
    context.commit('COURSE_UPDATED_WITH_TOPIC_LESSONS', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getTrendingCourses = async (context, data) => {
  try {
    const response = await fetchTrendingCourses(data)
    context.commit('TRENDING_COURSES_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getPopularCourses = async (context, data) => {
  try {
    const response = await fetchPopularCourses(data)
    context.commit('POPULAR_COURSES_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getFeaturedCourses = async context => {
  try {
    const response = await fetchFeaturedCourses()
    context.commit('FEATURED_COURSES_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getNewCourses = async (context, data) => {
  try {
    const response = await fetchNewCourses(data)
    context.commit('NEW_COURSES_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const submitCourseFeedback = async (context, data) => {
  try {
    const response = await postCourseFeedback(data)
    context.commit('COURSE_FEEDBACK_SUBMITTED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getAllCourses = async (context, number) => {
  try {
    const response = await fetchAllCourses(number)
    context.commit('COURSES_ALL_COURSES_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

export default {
  getTrendingCourses,
  getPopularCourses,
  getFeaturedCourses,
  getNewCourses,
  getCourseByIdWithTopicLessons,
  submitCourseFeedback,
  getAllCourses,
}
